import installationInstructions from './installationInstructions';

const applianceCategoryContent = {
  installationInstructions
}

export { applianceCategoryContent };
